/* eslint-disable @typescript-eslint/ban-ts-comment */
export const setURLParam = (key, value) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.set(key, value);
    history.replaceState({}, '', urlParams);
};
export const deleteURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    urlParams.searchParams.delete(key);
    history.replaceState({}, '', urlParams);
};
export const getURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.get(key);
};
export const getAllURLParam = (key) => {
    //  @ts-ignore
    const urlParams = new URL(window.location);
    return urlParams.searchParams.getAll(key);
};
export const handlise = (sentence) => {
    return sentence
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
};
export const generateUID = () => {
    return Date.now() + Math.random().toString(36).substr(2);
};
